/*
  德语
*/
export default {
  commodity: {}
}
